import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchInsurancePolicies } from "../../redux/insurancePolicies";
import Modal from "../../components/Modal";
import InsuranceInfo from "../../components/InsuranceInfo";
import DeactivationForm from "../../components/DeactivationForm";
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  makeStyles
} from "@material-ui/core";

import HeadingWithLine from "../HeadingWithLine";
import { setInsuranceToDisable } from "../../redux/insuranceToDisable.js";
import { fetchUserData } from "../../redux/user";
import "./my-insurances.scss";

const useStyles = makeStyles({
  table: {
    minWidth: 300
  },
  headRoot: {
    borderWidth: 0,
    borderBottomWidth: 1.5,
    borderColor: "#828282",
    borderStyle: "solid"
  },
  head: {
    fontWeight: 300,
    fontSize: 14,
    color: "#717271"
  },
  body: {
    fontSize: 16,
    color: "#4F4F4F"
  },
  icon: {
    width: 20
  }
});

export default function MyInsurances() {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { insurancePolicies, insuranceToDisable } = useSelector(
    ({ insurancePolicies, insuranceToDisable }) => ({
      insurancePolicies: insurancePolicies.policies,
      insuranceToDisable: insuranceToDisable
    })
  );
  const [open, setOpen] = useState(false);

  useEffect(() => {
    dispatch(fetchInsurancePolicies());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClick = (insurance) => {
    dispatch(fetchUserData());
    dispatch(setInsuranceToDisable(insurance));
    setOpen(true);
  };

  const closeModal = (isOpen) => {
    setOpen(isOpen);
  };

  return (
    insurancePolicies.length > 0 && (
      <>
        {open && insuranceToDisable && (
          <Modal dismiss={true} closeModal={closeModal}>
            <>
              <h4>Quiero solicitar la baja de la póliza</h4>
              <InsuranceInfo insuranceData={insuranceToDisable} />
              <DeactivationForm
                closeModal={closeModal}
                insuranceData={insuranceToDisable}
              />
            </>
          </Modal>
        )}
        <Grid container>
          <Grid item xs={12}>
            <HeadingWithLine
              bold
              fontWeight={500}
              color="#004987"
              text={
                <>
                  <b>Mis Pólizas</b>
                </>
              }
            />
          </Grid>
          <Grid item xs={12} style={{ marginTop: 8 }}>
            <TableContainer component={Box}>
              <Table className={classes.table} aria-label="Mis polizas">
                <TableHead>
                  <TableRow>
                    <TableCell
                      classes={{ root: classes.headRoot, head: classes.head }}
                      variant="head"
                      align="center"
                    >
                      Compañia
                    </TableCell>
                    <TableCell
                      classes={{ root: classes.headRoot, head: classes.head }}
                      variant="head"
                      align="center"
                    >
                      Seguro
                    </TableCell>
                    <TableCell
                      classes={{ root: classes.headRoot, head: classes.head }}
                      variant="head"
                      align="center"
                    >
                      Nº de Póliza
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {insurancePolicies.map((insurance) => (
                    <TableRow key={insurance.policyNumber}>
                      <TableCell
                        classes={{ body: classes.body }}
                        variant="body"
                        align="center"
                        style={{ fontWeight: "bold" }}
                      >
                        {insurance.insuranceCompany.code}
                      </TableCell>
                      <TableCell
                        classes={{ root: classes.icon }}
                        align="center"
                        style={{
                          textTransform: "lowercase"
                        }}
                      >
                        {insurance.productDesc}
                      </TableCell>
                      <TableCell
                        classes={{ body: classes.body }}
                        variant="body"
                        align="center"
                        style={{
                          fontWeight: "bold"
                        }}
                      >
                        {insurance.policyNumber}
                      </TableCell>
                      <TableCell
                        classes={{ body: classes.body }}
                        align="center"
                        style={{
                          fontSize: 22
                        }}
                      >
                        <img
                          className="trashcan"
                          src={require("../../img/trash.svg")}
                          alt="dar de baja poliza"
                          onClick={() => handleClick(insurance)}
                          style={{ width: 25 }}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </>
    )
  );
}
